<template>
  <div class="input-group mt-2">
    <input v-model="title" placeholder="New Checklist Item" class="form-control" v-on:keyup.enter="submit">
    <div class="input-group-append">
      <button class="btn btn-outline-primary" type="button" @click="submit">Add</button>
    </div>
  </div>
</template>

<script>
  import api from "api";

  export default {
    data() {
      return {
        title: ''
      };
    },
    props: ['task'],
    methods: {
      submit: function() {
        if(this.title !== ''){
          api.createTaskItem({ task_id: this.task.id, title: this.title }).then(response => {
            this.title = '';
          });
        }
      }
    }
  }
</script>
